if (!Modernizr.mq('only all')) {
  require("./styles/styles-old-ie.scss");
} else {
  require("./styles/styles.scss");
}

require('babel/polyfill');

// Dependencies
import _ from 'lodash';

import * as ng from "angular";
import uiRouter from "angular-ui-router";
import ngSanitize from "angular-sanitize";
import ngAnimate from "angular-animate";
import ngCookies from "angular-cookies";

import matchmedia from "matchmedia-ng";
import ngautovalidate from "angular-auto-validate";
import smoothScroll from "ngSmoothScroll";

import aui from "angular-bootstrap/ui-bootstrap";
import auitpl from "angular-bootstrap/ui-bootstrap-tpls";

// Aon
import loadControllers from "./controllers";
import loadDirectives from "./directives";
import loadServices from "./services";
import loadFilters from "./filters";
import loadRoutes from "./config/routes";


let dependencies = [uiRouter, 'ngSanitize', 'ngCookies', 'matchmedia-ng', 'jcs-autoValidate', 'smoothScroll', 'ui.bootstrap', 'ui.bootstrap.tpls'];
if (Modernizr.csstransitions) {
  // ngAnimate broke <= IE7 - as it doesn't do anything for them anyway conditionally include it
  dependencies.push('ngAnimate');
}
const aon = angular.module("aon.comparator", dependencies);

loadControllers(aon);
loadDirectives(aon);
loadServices(aon);
loadFilters(aon);
loadRoutes(aon);

aon.constant('VERSION', {
  'id': __VERSION__,
});

aon.config(($httpProvider, $stateProvider, $urlRouterProvider, matchmediaProvider, $tooltipProvider) => {
  // Setup responsive breakpoints to match our css
  matchmediaProvider.rules.phone = "(max-width: 480px)";
  matchmediaProvider.rules.tablet = "(max-width: 768px)";
  matchmediaProvider.rules.desktop = "(max-width: 990px)";

  $tooltipProvider.options({appendToBody:false, placement:'bottom'});

  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }
  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
});

// NOTE: AonConfig is created in HTML with content passed from django directly. See comparator/index.html.
aon.run(function (AonConfig, validator, ErrorMessageResolver, defaultErrorMessageResolver, $sce) {
  defaultErrorMessageResolver.getErrorMessages().then(messages => {
    ErrorMessageResolver.setDefaultMessages(messages);
  });
  validator.setErrorMessageResolver(ErrorMessageResolver.resolve);


  // These fields need to be displayed as HTML
  const trustAsHtmlFields = ['aboutyou_blurb', 'compare_blurb', 'apply_blurb', 'landing_intro_text'],
        htmlValues = _(AonConfig.corporate).pick(trustAsHtmlFields).mapValues($sce.trustAsHtml).value();
  _.merge(AonConfig.corporate, htmlValues);
});



// WEBPACK FOOTER //
// ./src/entry.js